import { useCallback, useState } from 'react';
import { useSegmentTrack } from '@application/hooks/useSegment/useSegment';
import { FsCampaignWrapper } from '@src/application/modules/flagship/components/Campaigns/FsCampaignWrapper';
import { TagCampaignWrapper } from '@src/application/modules/tag/Campaigns/TagCampaignWrapper';
import { CampaignProps } from '@application/modules/shared/type';
import { QATest } from '@src/application/modules/tag/shared/tag/types';

const isQATest = (props: CampaignProps): props is Extract<CampaignProps, { test: QATest }> =>
  'testDatas' in props.test && 'targetingDetails' in props.test;

export function Campaign(props: CampaignProps) {
  const [expand, setExpand] = useState(false);
  const segmentTrack = useSegmentTrack();
  const handleExpand = useCallback(() => {
    const onType = 'type' in props ? ` on ${props.type}` : '';
    segmentTrack(`Qa - Click details campaigns${onType}`);
    setExpand((item) => !item);
  }, []);

  if (isQATest(props)) {
    return <TagCampaignWrapper test={props.test} handleExpand={handleExpand} expand={expand} header={props.header} />;
  }
  return (
    <FsCampaignWrapper
      type={props.type}
      test={props.test}
      handleExpand={handleExpand}
      expand={expand}
      header={props.header}
    />
  );
}
